import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-504c591e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["operation"]
const _hoisted_2 = { class: "operation-box-bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "operation-bar" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "operation-ball-box"
}
const _hoisted_5 = {
  key: 1,
  class: "operation-ball-box"
}
const _hoisted_6 = {
  key: 0,
  class: "operation-box-name"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Operation Init</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Operation Ready</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Dry Run Check</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Dry Run</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Cooling Down</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Dry Run Done</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Discharge Ready</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Discharge Check</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Discharge Run</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Discharge Run Done</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Operation Done</span></div>", 11)
const _hoisted_18 = [
  _hoisted_7
]
const _hoisted_19 = {
  key: 1,
  class: "operation-box-name"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Operation Init</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Card Check</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Weight Check</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Operation Ready</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Dry Run Check</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Dry Run</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Cooling Down</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Dry Run Done</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Discharge Ready</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Discharge Run Check</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Discharge Run</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Discharge Run Done</span></div><div class=\"operation-name-div\" data-v-504c591e><span class=\"operation-name\" data-v-504c591e>Operation Done</span></div>", 13)
const _hoisted_33 = [
  _hoisted_20
]

import { computed, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  operation: {
    type: Number,
    required: true,
  },
  status: {
    type: Number,
    required: true,
  },
  model: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props



const width = computed(() => {
  if (props.model >= 21) {
    if (props.operation === 40) {
      return `${0}%`;
    } else {
      if (
        props.operation === 1 ||
        props.operation === 2 ||
        props.operation === 3 ||
        props.operation === 4 ||
        props.operation === 5
      ) {
        return `${0}%`;
      } else if (props.operation === 6 || props.operation === 7) {
        return `${(100 / 12) * 1}%`;
      } else if (
        props.operation === 8 ||
        props.operation === 9 ||
        props.operation === 10 ||
        props.operation === 11 ||
        props.operation === 12 ||
        props.operation === 13
      ) {
        return `${(100 / 12) * 2}%`;
      } else if (props.operation === 14) {
        return `${(100 / 12) * 3}%`;
      } else if (props.operation === 15 || props.operation === 16) {
        return `${(100 / 12) * 4}%`;
      } else if (props.operation === 17 || props.operation === 18) {
        return `${(100 / 12) * 5}%`;
      } else if (props.operation === 19) {
        return `${(100 / 12) * 6}%`;
      } else if (props.operation === 20) {
        return `${(100 / 12) * 7}%`;
      } else if (props.operation === 21) {
        return `${(100 / 12) * 8}%`;
      } else if (props.operation === 22) {
        return `${(100 / 12) * 9}%`;
      } else if (props.operation === 23) {
        return `${(100 / 12) * 10}%`;
      } else if (props.operation === 24) {
        return `${(100 / 12) * 11}%`;
      } else if (props.operation === 25) {
        return `${(100 / 12) * 12}%`;
      } else {
        return console.log("현재 operation 값", props.operation);
      }
    }
  } else {
    if (props.operation === 20) {
      return `${0}%`;
    } else if (props.operation === 1) {
      return `${0}%`;
    } else if (props.operation === 2) {
      return `${(100 / 10) * 1}%`;
    } else if (props.operation === 3) {
      return `${(100 / 10) * 2}%`;
    } else if (props.operation === 4 || props.operation === 5) {
      return `${(100 / 10) * 3}%`;
    } else if (props.operation === 6) {
      return `${(100 / 10) * 4}%`;
    } else if (props.operation === 7) {
      return `${(100 / 10) * 5}%`;
    } else if (props.operation === 8) {
      return `${(100 / 10) * 6}%`;
    } else if (props.operation === 9) {
      return `${(100 / 10) * 7}%`;
    } else if (props.operation === 10) {
      return `${(100 / 10) * 8}%`;
    } else if (props.operation === 11) {
      return `${(100 / 10) * 9}%`;
    } else if (props.operation === 12) {
      return `${(100 / 10) * 10}%`;
    } else {
      return `현재 operation 값 : ${props.operation}%`;
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "operation-box",
    operation: props.operation
  }, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "operation-bar-active",
        style: _normalizeStyle({
          width: props.operation === 0 ? '' : _unref(width),
        })
      }, null, 4),
      (props.model <= 20)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 1,
            'operation-ball-before':
              props.operation > 1 && props.operation < 20,
            'operation-ball-active-error':
              (props.operation === 1 && props.status === 2) ||
              (props.operation === 1 && props.status === 3) ||
              props.operation === 20,
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 2,
            'operation-ball-before':
              props.operation > 2 && props.operation < 20,
            'operation-ball-active-error':
              (props.operation === 2 && props.status === 2) ||
              (props.operation === 2 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 3,
            'operation-ball-before':
              props.operation > 3 && props.operation < 20,
            'operation-ball-active-error':
              (props.operation === 3 && props.status === 2) ||
              (props.operation === 3 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active':
              props.operation === 4 || props.operation === 5,
            'operation-ball-before':
              props.operation > 4 && props.operation < 20,
            'operation-ball-active-error':
              (props.operation === 4 && props.status === 2) ||
              (props.operation === 4 && props.status === 3) ||
              (props.operation === 5 && props.status === 2) ||
              (props.operation === 5 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 6,
            'operation-ball-before':
              props.operation > 6 && props.operation < 20,
            'operation-ball-active-error':
              (props.operation === 6 && props.status === 2) ||
              (props.operation === 6 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 7,
            'operation-ball-before':
              props.operation > 7 && props.operation < 20,
            'operation-ball-active-error':
              (props.operation === 7 && props.status === 2) ||
              (props.operation === 7 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 8,
            'operation-ball-before':
              props.operation > 8 && props.operation < 20,
            'operation-ball-active-error':
              (props.operation === 8 && props.status === 2) ||
              (props.operation === 8 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 9,
            'operation-ball-before':
              props.operation > 9 && props.operation < 20,
            'operation-ball-active-error':
              (props.operation === 9 && props.status === 2) ||
              (props.operation === 9 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 10,
            'operation-ball-before':
              props.operation > 10 && props.operation < 20,
            'operation-ball-active-error':
              (props.operation === 10 && props.status === 2) ||
              (props.operation === 10 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 11,
            'operation-ball-before':
              props.operation > 11 && props.operation < 20,
            'operation-ball-active-error':
              (props.operation === 11 && props.status === 2) ||
              (props.operation === 11 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 12,
            'operation-ball-active-error':
              (props.operation === 12 && props.status === 2) ||
              (props.operation === 12 && props.status === 3),
          }])
            }, null, 2)
          ]))
        : _createCommentVNode("", true),
      (props.model >= 21)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active':
              props.operation === 1 ||
              props.operation === 2 ||
              props.operation === 3 ||
              props.operation === 4 ||
              props.operation === 5,
            'operation-ball-before':
              props.operation > 1 && props.operation < 40,
            'operation-ball-active-error':
              (props.operation === 1 && props.status === 2) ||
              (props.operation === 1 && props.status === 3) ||
              (props.operation === 2 && props.status === 2) ||
              (props.operation === 2 && props.status === 3) ||
              (props.operation === 3 && props.status === 2) ||
              (props.operation === 3 && props.status === 3) ||
              (props.operation === 4 && props.status === 2) ||
              (props.operation === 4 && props.status === 3) ||
              (props.operation === 5 && props.status === 2) ||
              (props.operation === 5 && props.status === 3) ||
              props.operation === 40,
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active':
              props.operation === 6 || props.operation === 7,
            'operation-ball-before':
              props.operation > 6 && props.operation < 40,
            'operation-ball-active-error':
              (props.operation === 6 && props.status === 2) ||
              (props.operation === 6 && props.status === 3) ||
              (props.operation === 7 && props.status === 2) ||
              (props.operation === 7 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active':
              props.operation === 8 ||
              props.operation === 9 ||
              props.operation === 10 ||
              props.operation === 11 ||
              props.operation === 12 ||
              props.operation === 13,
            'operation-ball-before':
              props.operation > 8 && props.operation < 40,
            'operation-ball-active-error':
              (props.operation === 8 && props.status === 2) ||
              (props.operation === 8 && props.status === 3) ||
              (props.operation === 9 && props.status === 2) ||
              (props.operation === 9 && props.status === 3) ||
              (props.operation === 10 && props.status === 2) ||
              (props.operation === 10 && props.status === 3) ||
              (props.operation === 11 && props.status === 2) ||
              (props.operation === 11 && props.status === 3) ||
              (props.operation === 12 && props.status === 2) ||
              (props.operation === 12 && props.status === 3) ||
              (props.operation === 13 && props.status === 2) ||
              (props.operation === 13 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 14,
            'operation-ball-before':
              props.operation > 14 && props.operation < 40,
            'operation-ball-active-error':
              (props.operation === 14 && props.status === 2) ||
              (props.operation === 14 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active':
              props.operation === 15 || props.operation === 16,
            'operation-ball-before':
              props.operation > 15 && props.operation < 40,
            'operation-ball-active-error':
              (props.operation === 15 && props.status === 2) ||
              (props.operation === 15 && props.status === 3) ||
              (props.operation === 16 && props.status === 2) ||
              (props.operation === 16 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active':
              props.operation === 17 || props.operation === 18,
            'operation-ball-before':
              props.operation > 17 && props.operation < 40,
            'operation-ball-active-error':
              (props.operation === 17 && props.status === 2) ||
              (props.operation === 17 && props.status === 3) ||
              (props.operation === 18 && props.status === 2) ||
              (props.operation === 18 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 19,
            'operation-ball-before':
              props.operation > 19 && props.operation < 40,
            'operation-ball-active-error':
              (props.operation === 19 && props.status === 2) ||
              (props.operation === 19 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 20,
            'operation-ball-before':
              props.operation > 20 && props.operation < 40,
            'operation-ball-active-error':
              (props.operation === 20 && props.status === 2) ||
              (props.operation === 20 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 21,
            'operation-ball-before':
              props.operation > 21 && props.operation < 40,
            'operation-ball-active-error':
              (props.operation === 21 && props.status === 2) ||
              (props.operation === 21 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 22,
            'operation-ball-before':
              props.operation > 22 && props.operation < 40,
            'operation-ball-active-error':
              (props.operation === 22 && props.status === 2) ||
              (props.operation === 22 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 23,
            'operation-ball-before':
              props.operation > 23 && props.operation < 40,
            'operation-ball-active-error':
              (props.operation === 23 && props.status === 2) ||
              (props.operation === 23 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 24,
            'operation-ball-before':
              props.operation > 24 && props.operation < 40,
            'operation-ball-active-error':
              (props.operation === 24 && props.status === 2) ||
              (props.operation === 24 && props.status === 3),
          }])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["operation-ball", {
            'operation-ball-active': props.operation === 25,
            'operation-ball-active-error':
              (props.operation === 25 && props.status === 2) ||
              (props.operation === 25 && props.status === 3),
          }])
            }, null, 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    (props.model <= 20)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_18))
      : _createCommentVNode("", true),
    (props.model >= 21)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_33))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})